/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConversationTypePutRequest
 */
export interface ConversationTypePutRequest {
    /**
     * Unique identifier for a conversation type.
     * @type {string}
     * @memberof ConversationTypePutRequest
     */
    id: string;
    /**
     * A description of what this conversation type is used for.
     * @type {string}
     * @memberof ConversationTypePutRequest
     */
    description?: string | null;
    /**
     * If set, all user participants will appear as the same user in the conversation to client participants.
     * @type {string}
     * @memberof ConversationTypePutRequest
     */
    displayNameSharedByUsers?: string | null;
    /**
     * If set, all user participants share the read status
     * @type {boolean}
     * @memberof ConversationTypePutRequest
     */
    sharedReadStatusForUserParticipants?: boolean | null;
    /**
     * If set, all workflow participants will appear with this name in the conversation to client participants.
     * @type {string}
     * @memberof ConversationTypePutRequest
     */
    displayNameForWorkflowParticipants?: string | null;
    /**
     * A JSON Schema describing the data expected in the conversation.
     * @type {any}
     * @memberof ConversationTypePutRequest
     */
    conversationDataSchema?: any | null;
    /**
     * A handlebars template string used to render the conversation data in a list view. The template can contain placeholders for data in the conversation data schema.
     * @type {string}
     * @memberof ConversationTypePutRequest
     */
    conversationDataListItemTemplate: string;
    /**
     * An HTML template to reader the header in the client app which has dynamic values based on the conversation_data
     * @type {string}
     * @memberof ConversationTypePutRequest
     */
    clientAppHeaderTemplate?: string | null;
    /**
     * If set, the SMS messages will have this value as sender
     * @type {string}
     * @memberof ConversationTypePutRequest
     */
    smsSenderId?: string | null;
    /**
     * A map of template types to template names. If not provided, system default templates will be used.
     * @type {{ [key: string]: string; }}
     * @memberof ConversationTypePutRequest
     */
    messageTemplates?: { [key: string]: string; } | null;
    /**
     * The number of days conversations of this type will be retained before automatic deletion.
     * @type {number}
     * @memberof ConversationTypePutRequest
     */
    retentionPolicyDays?: number | null;
}

/**
 * Check if a given object implements the ConversationTypePutRequest interface.
 */
export function instanceOfConversationTypePutRequest(value: object): value is ConversationTypePutRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('conversationDataListItemTemplate' in value) || value['conversationDataListItemTemplate'] === undefined) return false;
    return true;
}

export function ConversationTypePutRequestFromJSON(json: any): ConversationTypePutRequest {
    return ConversationTypePutRequestFromJSONTyped(json, false);
}

export function ConversationTypePutRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConversationTypePutRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'description': json['description'] == null ? undefined : json['description'],
        'displayNameSharedByUsers': json['display_name_shared_by_users'] == null ? undefined : json['display_name_shared_by_users'],
        'sharedReadStatusForUserParticipants': json['shared_read_status_for_user_participants'] == null ? undefined : json['shared_read_status_for_user_participants'],
        'displayNameForWorkflowParticipants': json['display_name_for_workflow_participants'] == null ? undefined : json['display_name_for_workflow_participants'],
        'conversationDataSchema': json['conversation_data_schema'] == null ? undefined : json['conversation_data_schema'],
        'conversationDataListItemTemplate': json['conversation_data_list_item_template'],
        'clientAppHeaderTemplate': json['client_app_header_template'] == null ? undefined : json['client_app_header_template'],
        'smsSenderId': json['sms_sender_id'] == null ? undefined : json['sms_sender_id'],
        'messageTemplates': json['message_templates'] == null ? undefined : json['message_templates'],
        'retentionPolicyDays': json['retention_policy_days'] == null ? undefined : json['retention_policy_days'],
    };
}

export function ConversationTypePutRequestToJSON(json: any): ConversationTypePutRequest {
    return ConversationTypePutRequestToJSONTyped(json, false);
}

export function ConversationTypePutRequestToJSONTyped(value?: ConversationTypePutRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'description': value['description'],
        'display_name_shared_by_users': value['displayNameSharedByUsers'],
        'shared_read_status_for_user_participants': value['sharedReadStatusForUserParticipants'],
        'display_name_for_workflow_participants': value['displayNameForWorkflowParticipants'],
        'conversation_data_schema': value['conversationDataSchema'],
        'conversation_data_list_item_template': value['conversationDataListItemTemplate'],
        'client_app_header_template': value['clientAppHeaderTemplate'],
        'sms_sender_id': value['smsSenderId'],
        'message_templates': value['messageTemplates'],
        'retention_policy_days': value['retentionPolicyDays'],
    };
}

